import { MediaType, Orientation, Communication } from './enums';
import { AnalyticsError, ErrorCodes } from './errors';
import { KuxEventWithParam } from './events';

function validateBasePlaybackArguments(data: PlaybackBaseEventData) {
  if (data.mediaType === MediaType.recording && !data.recordingId) {
    throw new AnalyticsError(ErrorCodes.recordingIdMissing);
  }
  if (
    (data.mediaType === MediaType.live ||
      data.mediaType === MediaType.catchup ||
      data.mediaType === MediaType.recording) &&
    !data.epgId
  ) {
    throw new AnalyticsError(ErrorCodes.epgIdMissing);
  }
}

export class PlaybackBaseEventData extends KuxEventWithParam {
  screenOrientation?: Orientation;
  /**
   * The ID of the specific media that is being played. In case of live, catchup and recording this is the linear channel ID
   */
  // @ts-expect-error TODO Fix
  mediaId: number;
  /**
   * Position on the media in MS when the playback action occurred
   */
  // @ts-expect-error TODO Fix
  mediaPosition: number;
  /**
   * EPG program ID in case of live / catchup or recording content is being played
   */
  epgId?: string;
  /**
   * cDVR internal recording ID, in case of recorded content being played
   */
  recordingId?: string;
  /**
   * Media type that that is being played, available options: [[MediaType]]
   */
  // @ts-expect-error TODO Fix
  mediaType: MediaType;
  /**
   * The URL used to play the content as reported by the player.
   */
  playbackUrl?: string;
  /**
   * The unique identifier for the specific file that is being played
   */
  fileId?: string;
  /**
   * The played file type
   */
  fileType?: string;
  /**
   * Type of communication being used
   */
  communication?: Communication;
  /**
   * Current bitrate that is being used
   */
  // @ts-expect-error TODO Fix
  bitrate: number;

  constructor(path: string, data: PlaybackBaseEventData) {
    super(path, data);
    validateBasePlaybackArguments(data);
  }
}
